import React from "react";
import I18n from "i18n-js";

import { getHumanDate } from "../../services/date";

const TrainingCourse = ({ uuid, title, created_at, selected }) => (
  <a
    className={selected ? "training-course selected" : "training-course"}
    href={`/training-courses/${uuid}?locale=${I18n.locale}`}
  >
    <div className="title">{title}</div>
    <div className="timestamp">{getHumanDate(created_at)}</div>
  </a>
);

export default TrainingCourse;
